var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-5", attrs: { flat: "", loading: _vm.loading } },
    [
      _c("v-card-text", { staticClass: "pa-0" }, [
        _c(
          "div",
          { staticClass: "panel-content px-4 py-4" },
          [
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-center mb-2" },
                  [
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.$t("current-organization"))),
                    ]),
                    _c(
                      "v-chip",
                      {
                        staticClass: "ml-2",
                        attrs: { "x-small": "", color: "grey lighten-2" },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.currentOrgConnectors.length) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                !_vm.loading && _vm.currentOrgConnectors.length === 0
                  ? _c(
                      "v-alert",
                      { attrs: { type: "info", outlined: "", dense: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("connector.no-current-connectors")) +
                            " "
                        ),
                      ]
                    )
                  : _c(
                      "v-list",
                      { staticClass: "pa-0" },
                      _vm._l(_vm.currentOrgConnectors, function (row) {
                        return _c("connector-row", {
                          key: row.id,
                          attrs: {
                            row: row,
                            "expanded-sessions": _vm.expandedSessions[row.id],
                            "sessions-loading":
                              _vm.sessionsLoading[row.organizationId],
                            sessions: _vm.sessions[row.organizationId] || [],
                          },
                          on: {
                            "toggle-sessions": function ($event) {
                              return _vm.toggleSessions(row)
                            },
                            update: function ($event) {
                              return _vm.openUpdateDialog(row)
                            },
                            "toggle-enabled": function ($event) {
                              return _vm.confirmToggleEnabled(row)
                            },
                            delete: function ($event) {
                              return _vm.confirmDelete(row)
                            },
                            copy: _vm.copyToClipboard,
                          },
                        })
                      }),
                      1
                    ),
              ],
              1
            ),
            _c("v-divider", { staticClass: "mb-4" }),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "d-flex align-center mb-2 other-section-header",
                  on: {
                    click: function ($event) {
                      _vm.showOther = !_vm.showOther
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-2", attrs: { small: "" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.showOther
                            ? "mdi-chevron-down"
                            : "mdi-chevron-right"
                        ) +
                        " "
                    ),
                  ]),
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("connector.other-organizations"))),
                  ]),
                  _c(
                    "v-chip",
                    {
                      staticClass: "ml-2",
                      attrs: { "x-small": "", color: "grey lighten-2" },
                    },
                    [_vm._v(" " + _vm._s(_vm.otherConnectors.length) + " ")]
                  ),
                  _c("v-spacer"),
                  _vm.showOther && _vm.otherConnectors.length > 0
                    ? _c(
                        "span",
                        { staticClass: "text-caption grey--text mr-2" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.filteredOtherConnectors.length) +
                              " / " +
                              _vm._s(_vm.otherConnectors.length) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.showOther
                ? _c(
                    "div",
                    [
                      _c("v-text-field", {
                        staticClass: "mb-2",
                        attrs: {
                          placeholder: _vm.$t("search") + "...",
                          "prepend-inner-icon": "mdi-magnify",
                          outlined: "",
                          dense: "",
                          clearable: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.otherSearch,
                          callback: function ($$v) {
                            _vm.otherSearch = $$v
                          },
                          expression: "otherSearch",
                        },
                      }),
                      _vm.filteredOtherConnectors.length
                        ? _c("v-virtual-scroll", {
                            attrs: {
                              items: _vm.filteredOtherConnectors,
                              "item-height": _vm.expandedRowHeight,
                              height: _vm.virtualHeight,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ item }) {
                                    return [
                                      _c("connector-row", {
                                        attrs: {
                                          row: item,
                                          "expanded-sessions":
                                            _vm.expandedSessions[item.id],
                                          "sessions-loading":
                                            _vm.sessionsLoading[
                                              item.organizationId
                                            ],
                                          sessions:
                                            _vm.sessions[item.organizationId] ||
                                            [],
                                        },
                                        on: {
                                          "toggle-sessions": function ($event) {
                                            return _vm.toggleSessions(item)
                                          },
                                          update: function ($event) {
                                            return _vm.openUpdateDialog(item)
                                          },
                                          "toggle-enabled": function ($event) {
                                            return _vm.confirmToggleEnabled(
                                              item
                                            )
                                          },
                                          delete: function ($event) {
                                            return _vm.confirmDelete(item)
                                          },
                                          copy: _vm.copyToClipboard,
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4032934987
                            ),
                          })
                        : _vm.otherSearch && !_vm.loading
                        ? _c(
                            "v-alert",
                            {
                              attrs: { type: "info", outlined: "", dense: "" },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("no-results")) + " ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.updateDialog,
            callback: function ($$v) {
              _vm.updateDialog = $$v
            },
            expression: "updateDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("connector.update-title")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.updateDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "updateForm",
                      model: {
                        value: _vm.updateFormValid,
                        callback: function ($$v) {
                          _vm.updateFormValid = $$v
                        },
                        expression: "updateFormValid",
                      },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("connector.crm-id"),
                          rules: [
                            (v) =>
                              !!(v && v.trim()) ||
                              _vm.$t("error.validator.required"),
                          ],
                          outlined: "",
                          dense: "",
                        },
                        on: {
                          blur: function ($event) {
                            _vm.updateData.crmId = (
                              _vm.updateData.crmId || ""
                            ).trim()
                          },
                        },
                        model: {
                          value: _vm.updateData.crmId,
                          callback: function ($$v) {
                            _vm.$set(_vm.updateData, "crmId", $$v)
                          },
                          expression: "updateData.crmId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      on: {
                        click: function ($event) {
                          _vm.updateDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: !_vm.updateFormValid || _vm.saving,
                        loading: _vm.saving,
                      },
                      on: { click: _vm.saveUpdate },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("confirmation-dialog", { ref: "confirmDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }